/**
 * Queues a toast to be shown after the next page load (e.g. after logout redirect).
 * Use queueDeferredToast before redirect; call showDeferredToast once after app mount.
 */
import i18n from 'i18n';
import showToast from 'utils/toast';

const STORAGE_KEY = 'deferredToast';

type DeferredToastData = {
  translationKey: string;
  params?: Record<string, string>;
};

export const queueDeferredToast = (data: DeferredToastData) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

const displayToast = ({ translationKey, params }: DeferredToastData) => {
  showToast(
    {
      title: i18n.t(translationKey, params) as string,
      variant: 'info',
    },
    { autoClose: 15000 },
  );
};

export const showDeferredToast = () => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return;

  sessionStorage.removeItem(STORAGE_KEY);

  let data: DeferredToastData;
  try {
    data = JSON.parse(raw) as DeferredToastData;
  } catch {
    return;
  }

  if (i18n.isInitialized) {
    displayToast(data);
  } else {
    const onReady = () => {
      i18n.off('initialized', onReady);
      displayToast(data);
    };
    i18n.on('initialized', onReady);
  }
};
